var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("首页")]),_c('p',[_vm._v("欢迎使用管理系统")])])
}]

export { render, staticRenderFns }